import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import { defaultLosJsonHeaders } from '../requestHeaders'
import {
    BonusProgram,
    BonusProgramApiResponse,
    EMPTY_PROGRAM,
    parseBonusProgram,
} from './parseBonusProgram'

export default async function getCurrentBonusProgram(): Promise<BonusProgram> {
    try {
        const url = `${config.API_BASE_URL}/api/v3/dealerships/bonus-program/`

        const { data } = await axios.get<BonusProgramApiResponse>(url, {
            withCredentials: true,
            headers: defaultLosJsonHeaders(),
        })

        return parseBonusProgram(data)
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to get bonus program: ${axiosError.message}`,
            axiosError,
        )

        return EMPTY_PROGRAM
    }
}
